export const CURRENT_SUBSCRIPTION_MANAGEMENT_OVERLAY_PANE_CLASS = 'current-subscription-management-overlay-pane';
